var stylesBreadcrumb = {"breadcrumb":"bc-breadcrumb__breadcrumb","icon":"bc-breadcrumb__icon","text":"bc-breadcrumb__text"};

export { stylesBreadcrumb as default };
